// Detects errors caused by loading an app bundle/chunk that no longer exists
// on the server. This is the classic "the page was open before a Netlify
// deploy, and the hashed chunk it asks for is now gone" situation.
// ----------------------------------------------------------------------

export default function isDeployError(error) {
  if (!error) return false;

  const nestedError = error.error || error.reason;
  const name = error.name || nestedError?.name || '';
  const message =
    (typeof error === 'string' && error) ||
    error.message ||
    (typeof nestedError === 'string' && nestedError) ||
    nestedError?.message ||
    '';
  const resource = error.target;
  const resourceUrl = resource?.src || resource?.href || '';
  const isHashedChunkResource =
    ['SCRIPT', 'LINK'].includes(resource?.tagName) &&
    /\/static\/(?:js|css)\/[^/]+\.(?:js|css)(?:\?|$)/i.test(resourceUrl);

  return (
    isHashedChunkResource ||
    name === 'ChunkLoadError' ||
    /Loading chunk \d+ failed/i.test(message) ||
    /Loading JavaScript chunk \d+ failed/i.test(message) ||
    /Loading CSS chunk/i.test(message) ||
    /ChunkLoadError/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    // Server returned index.html (text/html) instead of the missing JS chunk.
    /'text\/html' is not a valid JavaScript MIME type/i.test(message) ||
    /Expected a JavaScript(?:-or-Wasm)? module script.*text\/html/i.test(
      message
    ) ||
    /Unexpected token '<'/i.test(message) ||
    /import\(\).*failed/i.test(message)
  );
}
